var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post",on:{"click":_vm.toPost}},[_vm._t("default"),(_vm.toastLoading && _vm.screening && !_vm.savedFilePathMapRef[_vm.savedId])?_c('toast-loading',{attrs:{"value":_vm.loadingPercent,"type":"circle"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }